exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-0220da42]{cursor:default}.tooltip:hover .text[data-v-0220da42]{display:block}.icon[data-v-0220da42]{vertical-align:bottom}.text[data-v-0220da42]{display:none;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:35px;-webkit-box-sizing:border-box;box-sizing:border-box;width:200px;text-align:center}.text[data-v-0220da42]:before{content:'';display:block;width:0;height:0;position:absolute;border:10px solid transparent;border-top:10px solid #707070;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:-20px}\n", ""]);

// exports
